module.exports = __webpack_public_path__ + "vue-app/img/plus.989a75bf.svg";